import {RouteConfig} from "vue-router"
import Playground from "@/playground/Playground.vue"
import JdpJobIndex from "@/playground/jobs/JdpJobIndex.vue"
import JdpDashboard from "@/playground/dashboard/JdpDashboard.vue"
import JdpSingleJob from "@/playground/jobs/JdpSingleJob.vue"
import JdpJobCandidates from "@/playground/jobs/JdpJobCandidates.vue"
import JdpJobOverview from "@/playground/jobs/JdpJobOverview.vue"
import JdpAttributeManager from "@/playground/company-settings/JdpAttributeManager.vue"
import JdpCompanySettings from "@/playground/company-settings/JdpCompanySettings.vue"
import JdpTestSettings from "@/playground/company-settings/JdpTestSettings.vue"
import JdpCandidateProfile from "@/playground/jobs/JdpCandidateProfile.vue"
import JdpStageView from "@/playground/jobs/JdpStageView.vue"


export const playgroundRoutes: RouteConfig = {
        path: '/playground',
        name: 'playground',
        component: Playground,
        redirect: {name: 'playground.dashboard'},
        children: [
            {
                path: 'dashboard',
                name: 'playground.dashboard',
                component: JdpDashboard
            },
            {
                path: 'jobs',
                name: 'playground.jobs',
                component: JdpJobIndex
            },
            {
                path: 'jobs/1',
                name: 'playground.jobs.single',
                component: JdpSingleJob,
                redirect: {name: 'playground.jobs.single.candidates'},
                children: [
                    {
                        path: 'overview',
                        name: 'playground.jobs.single.overview',
                        component: JdpJobOverview
                    },
                    {
                        path: 'candidates',
                        name: 'playground.jobs.single.candidates',
                        component: JdpJobCandidates,
                        children: [
                            {
                                path: 'candidate',
                                name: 'playground.jobs.single.candidates.candidate',
                                component: JdpCandidateProfile
                            },
                            {
                                path: 'stage',
                                name: 'playground.jobs.single.candidates.stage',
                                component: JdpStageView
                            }
                        ]
                    },
                ]
            },
            {
                path: 'company-settings',
                name: 'playground.company-settings',
                redirect: {name: 'playground.company-settings.test-settings'},
                component: JdpCompanySettings,
                children: [
                    // {
                    //     path: 'attributes',
                    //     name: 'playground.company-settings.attribute-manager',
                    //     component: JdpAttributeManager
                    // },
                    {
                        path: 'test',
                        name: 'playground.company-settings.test-settings',
                        component: JdpTestSettings
                    },
                    {
                        path: 'users',
                        name: 'playground.company-settings.users',
                        component: JdpTestSettings
                    },
                ]
            },
        ]
    }
